import React, { Component } from "react";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Card,
  CardBody,
  Col,
  Row,
  ModalHeader,
} from "reactstrap";
import "toastr/build/toastr.min.css";
import { Formik, Field, Form } from "formik";
import { withTranslation } from "react-i18next";
import { getCurrencyList, getRavenTransactionTypeDefList, getTransactionProvisionSearch, getTransactionProvisionSettleSearch } from "store/actions";
import RavenFormikField from "components/Common/RavenFormikField";
import { getInitValue, getInitValueDate, getInitValueNull } from "components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";

let selectedBankGuid;
let selectedRavenTransactionTypeGuid;
let selectedCurrencyGuid;
class SearchContentTransactionProvision extends Component {
  constructor(props) {
    super(props);

    this.state = {
      record: "",
      recordList: [],
      filterSelected: "",
    };
  }

  handleSearch = values => {
    const { onGetTransactionProvisionSearch } = this.props;

    values.bankGuid = selectedBankGuid;
    if (values.bankGuid == "" || values.bankGuid == undefined)
      values.bankGuid = null;

    values.ravenTransactionTypeGuid = selectedRavenTransactionTypeGuid;
    if (values.ravenTransactionTypeGuid == "" || values.ravenTransactionTypeGuid == undefined) {
      values.ravenTransactionTypeGuid = null;
    }

    values.currencyGuid = selectedCurrencyGuid;
    if (values.currencyGuid == "" || values.currencyGuid == undefined) {
      values.currencyGuid = null;
    }

    onGetTransactionProvisionSearch(values);
  };

  handleBankTransactionChange = (options) => {
    selectedBankGuid = options.value;
  }

  handleRavenTransactionTypeChange = (options) => {
    selectedRavenTransactionTypeGuid = options.value;
  }

  handleCurrencyChange = (options) => {
    selectedCurrencyGuid = options.value;
  }

  render() {
    const { filterSelected } = this.state;
    return (
      <React.Fragment>
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <Formik
                  enableReinitialize={true}
                  disabled={true}
                  initialValues={{
                    bankGuid: getInitValue(filterSelected, filterSelected.bankGuid),
                    currencyGuid: getInitValue(filterSelected, filterSelected.currencyGuid),
                    transactionStartDate: getInitValueDate(filterSelected, filterSelected.transactionStartDate, 0) ? null : null,
                    transactionEndDate: getInitValueDate(filterSelected, filterSelected.transactionEndDate, 0) ? null : null,
                    ravenTransactionTypeGuid: getInitValue(filterSelected, filterSelected.ravenTransactionTypeGuid),
                    orderId: getInitValueNull(filterSelected, filterSelected.orderId),
                    authorizationNumber: getInitValueNull(filterSelected, filterSelected.authorizationNumber),
                    transactionAmountLow: getInitValueNull(filterSelected, filterSelected.transactionAmountLow) ? null : null,
                    transactionAmountHigh: getInitValueNull(filterSelected, filterSelected.transactionAmountHigh) ? null : null,
                  }}
                  validationSchema={Yup.object().shape({
                    orderId: Yup.string()
                      .max(40, this.props.t("maxLengthError").format("40")).nullable(),
                    authorizationNumber: Yup.string()
                      .max(6, this.props.t("maxLengthError").format("6")).nullable(),
                    transactionAmountLow: Yup.number().nullable(),
                    transactionAmountHigh: Yup.number().nullable(),
                  })}
                  onSubmit={values => {
                    if (values.transactionStartDate == "")
                      values.transactionStartDate = null;

                    if (values.transactionEndDate == "")
                      values.transactionEndDate = null;

                    if (values.ravenTransactionTypeGuid == undefined || values.ravenTransactionTypeGuid == "")
                      values.ravenTransactionTypeGuid = null;

                    if (values.bankGuid == undefined || values.bankGuid == "")
                      values.bankGuid = null;

                    if (values.currencyGuid == undefined || values.currencyGuid == "")
                      values.currencyGuid = null;

                    if (values.transactionAmountHigh == "")
                      values.transactionAmountHigh = null;

                    if (values.transactionAmountLow == "")
                      values.transactionAmountLow = null;

                    if (values.orderId == "")
                      values.orderId = null;

                    if (values.authorizationNumber == "")
                      values.authorizationNumber = null;
                    values.userName = localStorage.getItem("username");
                    this.handleSearch(values);
                  }}
                >
                  {({ errors, touched, setFieldValue }) => (
                    <Form>
                      <Row>
                        <Col lg={12}>
                          <div className="mb-3">
                            <details open={true}>
                              <summary>
                                {this.props.t("transactionDate")}
                              </summary>

                              <Row>
                                <Col lg={6} className="col-7">
                                  <Field
                                    name="transactionStartDate"
                                    className="form-control"
                                    type="date"
                                  />
                                </Col>
                                <Col lg={6} className="col-7">
                                  <Field
                                    name="transactionEndDate"
                                    className="form-control"
                                    type="date"
                                  />
                                </Col>
                              </Row>
                            </details>
                          </div>
                        </Col>

                        <Col lg={12}>
                          <div className="mb-3">
                            <details open={true}>
                              <summary>{this.props.t("transactionType")}</summary>

                              <RavenFormikField
                                errors={errors}
                                touched={touched}
                                name={"ravenTransactionTypeGuid"}
                                label={""}
                                component="multiselect"
                                type="singleselect"
                                valueList={this.props.ravenTransactionTypeRecordList.filter(i => i.financialTypeGuid === 1 || i.financialTypeGuid === 2)} 
                                nameOnValueList={["ravenTransactionCode", "description"]}
                                onChange={this.handleRavenTransactionTypeChange}
                              />

                            </details>
                          </div>
                        </Col>

                        <Col lg={12} className="col-12">
                          <div className="mb-3">
                            <details open={true}>
                              <summary>
                                {this.props.t("domesticBankListGuid")}
                              </summary>

                              <RavenFormikField
                                errors={errors}
                                touched={touched}
                                name={"bankGuid"}
                                label={""}
                                component="multiselect"
                                type="singleselect"
                                valueList={this.props.domesticBankRecordList}
                                nameOnValueList={"bankName"}
                                onChange={this.handleBankTransactionChange}
                              />
                            </details>
                          </div>
                        </Col>

                        <Col lg={12}>
                          <div className="mb-3">
                            <details open={true}>
                              <summary>
                                {this.props.t("orderId")}
                              </summary>

                              <Field
                                name="orderId"
                                className={"form-control"}
                                type="text"
                              />

                            </details>
                          </div>
                        </Col>
                        <Col lg={12}>
                          <div className="mb-3">
                            <details open={true}>
                              <summary>
                                {this.props.t("authorizationNumber")}
                              </summary>

                              <Field
                                name="authorizationNumber"
                                className={"form-control"}
                                type="text"
                              />

                            </details>
                          </div>
                        </Col>

                        <Col lg={12}>
                          <div className="mb-3">
                            <details open={true}>
                              <summary>
                                {this.props.t("transactionAmount")}
                              </summary>

                              <Row>
                                <Col lg={6} className="col-7">
                                  <RavenFormikField
                                    errors={errors}
                                    touched={touched}
                                    label={""}
                                    name="transactionAmountLow"
                                    component="textbox"
                                    type="text"
                                  />
                                </Col>
                                <Col lg={6} className="col-7">
                                  <RavenFormikField
                                    errors={errors}
                                    touched={touched}
                                    label={""}
                                    name="transactionAmountHigh"
                                    component="textbox"
                                    type="text"
                                  />
                                </Col>
                              </Row>
                            </details>
                          </div>
                        </Col>

                        <Col lg={12}>
                          <div className="mb-3">
                            <details open={true}>
                              <summary>
                                {this.props.t("transactionCurrency")}
                              </summary>

                              <RavenFormikField
                                errors={errors}
                                touched={touched}
                                name={"currencyGuid"}
                                label={""}
                                component="multiselect"
                                type="singleselect"
                                valueList={this.props.currencyDefRecordList}
                                nameOnValueList={["alphabeticCode", "currencyName"]}
                                onChange={this.handleCurrencyChange}
                              />

                            </details>
                          </div>
                        </Col>
                      </Row>

                      <ModalHeader
                        style={{ marginBottom: "10px" }}
                      ></ModalHeader>

                      <Row>
                        <Col lg={10}>
                          <div style={{ textAlign: "right" }}>
                            <button
                              disabled={this.props.loading}
                              type="submit"
                              className="btn btn-success save-event"
                              style={{ marginRight: "3px" }}
                            >
                              {this.props.t("search")}
                            </button>

                            <button
                              disabled={this.props.loading}
                              type="reset"
                              className="btn btn-secondary save-customer"
                              onClick={() => {
                                setFieldValue("ravenTransactionTypeGuid", "")
                                setFieldValue("bankGuid", "")
                                setFieldValue("currencyGuid", "")
                                setFieldValue("orderId", "")
                                setFieldValue("transactionStartDate", "")
                                setFieldValue("transactionEndDate", "")
                                setFieldValue("transactionAmountHigh", "")
                                setFieldValue("transactionAmountLow", "")
                                setFieldValue("authorizationNumber", "")
                              }}
                            >
                              {this.props.t("clear")}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

SearchContentTransactionProvision.propTypes = {
  t: PropTypes.any,
  className: PropTypes.any,
  domesticBankRecordList: PropTypes.array,
  onGetTransactionProvisionSearch: PropTypes.func,
  onGetRavenTransactionTypeList: PropTypes.func,
  ravenTransactionTypeRecordList: PropTypes.array,
  currencyDefRecordList: PropTypes.array,
  onGetCurrencyList: PropTypes.func,
  loading: PropTypes.any,
};

const mapStateToProps = ({ domesticBankDefinition, ravenTransactionTypeDef, currencyDefinition, transactionProvision }) => ({
  ravenTransactionTypeRecordList: ravenTransactionTypeDef.recordList,
  currencyDefRecordList: currencyDefinition.recordList,
  domesticBankRecordList: domesticBankDefinition.recordList,
  loading: transactionProvision.loading,
});

const mapDispatchToProps = dispatch => ({
  onGetCurrencyList: () => dispatch(getCurrencyList()),
  onGetTransactionProvisionSearch: values => dispatch(getTransactionProvisionSearch(values)),
  onGetRavenTransactionTypeList: () => dispatch(getRavenTransactionTypeDefList()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(SearchContentTransactionProvision));
